module.exports = __webpack_public_path__ + "img/002.1918dc56.jpg";